/**
 * SignInPresenter
 * --
 */
import React from 'react';
import { Content, Row, Col, Title, Breadcrumb, Text } from 'components';
import { Input, Checkbox, Button } from 'antd';

import Naver from 'assets/icon/naver_login.png';
import Kakao from 'assets/icon/kakao_login.png';
import Google from 'assets/icon/google_login.png';
import Apple from 'assets/icon/apple_login.png';
import MessageAlert from '../../../utils';

const SignInPresenter = ({
  accountRef,
  passwordRef,
  inputValue,
  status,
  message,
  onSubmit,
  onChange,
  navigate,
  onSocialLogin,
  screenSize,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: screenSize >= 768 ? 32 : 28,
      lineHeight: '120%',
      fontFamily: `"Dela Gothic One", sans-serif`,
      fontWeight: 400,
      fontStyle: 'normal',
      color: 'var(--black-color)',
    },

    input: {
      width: '100%',
      height: screenSize >= 768 ? 44 : 35,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '180%',
    },

    message: {
      fontSize: 12,
      fontWeight: 400,
      color: 'var(--danger-color)',
      position: 'absolute',
      top: '-50%',
      left: 0,
      display: status === 'default' ? 'none' : 'inline-block',
    },

    button: {
      fontSize: screenSize >= 768 ? 16 : 14,
      fontWeight: 700,
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    snsButton: {
      fontSize: 18,
      fontWeight: 500,
      lineHeight: '150%',
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      boxShadow: 'none',
      height: 44,
      width: 44,
    },

    text: {
      fontSize: screenSize >= 768 ? 16 : 14,
      fontWeight: 400,
      lineHeight: '150%',
      color: 'var(--black-color)',
    },

    linkButton: {
      padding: 0,
      color: 'var(--black-color)',
    },
  };

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content
      maxWidth={1820}
      padding={screenSize >= 768 ? '100px 0px' : '60px 0'}
    >
      <Row gutter={16}>
        <Col x={1} md={6} lg={8}></Col>
        <Col x={22} md={12} lg={8}>
          <Title align={'center'} style={{ ...styles.title }}>
            Login
          </Title>

          {/* 로그인 */}
          <Row gutter={16} style={{ marginTop: screenSize >= 768 ? 80 : 40 }}>
            <Col x={18} style={{ padding: 0 }}>
              <Content maxWidth={'100%'} padding={0}>
                <Input
                  ref={accountRef}
                  value={inputValue.user_account}
                  onChange={(e) => onChange('user_account', e.target.value)}
                  placeholder="아이디"
                  style={{
                    ...styles.input,
                    marginBottom: screenSize >= 768 ? 20 : 10,
                  }}
                  onPressEnter={() => onSubmit()}
                />
                <Input.Password
                  ref={passwordRef}
                  value={inputValue.password}
                  onChange={(e) => onChange('password', e.target.value)}
                  placeholder="비밀번호"
                  style={{ ...styles.input }}
                  onPressEnter={() => onSubmit()}
                />
              </Content>
            </Col>
            <Col x={6} style={{ paddingRight: 0 }}>
              <Button
                type="primary"
                style={{ ...styles.button }}
                onClick={() => onSubmit()}
              >
                로그인
              </Button>
            </Col>
          </Row>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginTop: 20,
              position: 'relative',
              top: 0,
              left: 0,
            }}
          >
            <p
              style={{
                ...styles.message,
              }}
            >
              {message}
            </p>
            <Checkbox
              style={{
                fontSize: screenSize >= 768 ? 18 : 14,
                fontWeight: 400,
                color: 'var(--black-color)',
              }}
              checked={inputValue?.is_save}
              onChange={(e) => onChange('is_save', e.target.checked)}
            >
              아이디 저장
            </Checkbox>
            {/* {console.log('inputValue', inputValue)} */}

            <Breadcrumb
              padding={10}
              items={[
                {
                  title: '아이디 찾기',
                  onClick: () => navigate('/find/account'),
                },
                {
                  title: '비밀번호 찾기',
                  onClick: () => navigate('/find/password'),
                },
              ]}
              itemStyle={{
                fontSize: 14,
                fontWeight: 400,
                color: 'var(--black-color)',
              }}
            />
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              gap: 8,
              marginTop: 4,
            }}
          >
            <Text size={14} weight={700}>
              기존 회원이신가요?
            </Text>
            <Button
              type="link"
              style={{ ...styles.linkButton }}
              onClick={() => navigate(`/common/member`)}
            >
              기존 회원 연동하기
            </Button>
          </div>
          {/* 로그인 끝 */}

          {/* 구분선 */}
          <Content
            maxWidth={'100%'}
            padding={screenSize >= 768 ? '80px 0px' : '60px 0'}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <span
              style={{
                width: '100%',
                height: 1,
                background: 'var(--black-color)',
              }}
            ></span>
          </Content>
          {/* 구분선 끝 */}

          {/* 회원가입*/}
          <Row gutter={16}>
            <Col x={12} style={{ display: 'flex', alignItems: 'center' }}>
              <p
                style={{
                  ...styles.text,
                }}
              >
                회원가입 후
                <br />
                다양한 혜택을 받아보세요!
                {/* <span style={{ fontWeight: 700 }}>최대 15% 할인 쿠폰</span>을
                받으세요! */}
              </p>
            </Col>
            <Col x={12}>
              <Button
                style={{
                  ...styles.button,
                  height: screenSize >= 768 ? 58 : 40,
                  borderRadius: 1,
                }}
                onClick={() => {
                  if (window.ReactNativeWebView) {
                    MessageAlert.info('order탭에서 진행해주세요.');
                    return;
                  }
                  navigate('/signup');
                }}
              >
                회원가입
              </Button>
            </Col>
          </Row>
          {/* 회원가입 끝 */}

          {/* SNS 간편 로그인 */}
          <Row gutter={16} style={{ marginTop: 60 }}>
            <Col
              x={24}
              md={12}
              style={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                marginBottom: screenSize >= 768 ? 0 : 20,
              }}
            >
              <p
                style={{
                  ...styles.text,
                }}
              >
                SNS 계정으로 로그인하기
              </p>
            </Col>
            <Col x={6} md={3} align="center">
              <Button
                type="primary"
                icon={<img src={Naver} alt="네이버 아이콘" />}
                style={{
                  ...styles.snsButton,
                  background: 'var(--naver-color)',
                  color: 'var(--white-color)',
                }}
                onClick={() => onSocialLogin('naver')}
              >
                {/* 네이버 */}
              </Button>
            </Col>
            <Col x={6} md={3} align="center">
              <Button
                type="primary"
                icon={<img src={Kakao} alt="카카오 아이콘" />}
                style={{
                  ...styles.snsButton,
                  background: 'var(--kakao-color)',
                  color: 'var(--black-color)',
                }}
                onClick={() => onSocialLogin('kakao')}
              >
                {/* 카카오 */}
              </Button>
            </Col>
            <Col x={6} md={3} align="center">
              <Button
                type="primary"
                icon={<img src={Google} alt="구글 아이콘" />}
                style={{
                  ...styles.snsButton,
                  background: '#F2F2F2',
                  color: 'var(--black-color)',
                }}
                onClick={() => onSocialLogin('google')}
              >
                {/* 구글 */}
              </Button>
            </Col>
            <Col x={6} md={3} align="center">
              <Button
                type="primary"
                icon={<img src={Apple} alt="애플 아이콘" />}
                style={{
                  ...styles.snsButton,
                  background: '#000000',
                  color: 'var(--black-color)',
                }}
                onClick={() => onSocialLogin('apple')}
              >
                {/* 애플 */}
              </Button>
            </Col>
          </Row>
          {/* SNS 간편 로그인 끝 */}
        </Col>
        <Col x={1} md={6} lg={8}></Col>
      </Row>
    </Content>
  );
};

export default SignInPresenter;
